// extracted by mini-css-extract-plugin
export default {"address":"Info_address__EFuD-","status":"Info_status__K02UX"};